import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ContactPage = () => {
  const [contactForm, setContactForm] = useState({
    subject: '',
    message: '',
    category: 'general'
  });
  const [myContacts, setMyContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [selectedContact, setSelectedContact] = useState(null);

  useEffect(() => {
    fetchMyContacts();
  }, []);

  const fetchMyContacts = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('https://builtfuturelife.com/api/my-contacts', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMyContacts(response.data.contacts || []);
    } catch (error) {
      console.error('Error fetching contacts:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setContactForm(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!contactForm.subject.trim() || !contactForm.message.trim()) {
      alert('Please fill in all required fields');
      return;
    }

    setSubmitting(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post('https://builtfuturelife.com/api/contact', contactForm, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      alert('Contact form submitted successfully! We will get back to you soon.');
      setContactForm({
        subject: '',
        message: '',
        category: 'general'
      });
      fetchMyContacts();
    } catch (error) {
      console.error('Error submitting contact form:', error);
      alert('Failed to submit contact form. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const viewContactDetails = async (contactId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`https://builtfuturelife.com/api/my-contacts/${contactId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSelectedContact(response.data.contact);
    } catch (error) {
      console.error('Error fetching contact details:', error);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'pending': return '#f59e0b';
      case 'read': return '#00d4ff';
      case 'replied': return '#10b981';
      case 'closed': return '#6b7280';
      default: return '#6b7280';
    }
  };

  const getStatusBgColor = (status) => {
    switch (status) {
      case 'pending': return 'rgba(245, 158, 11, 0.1)';
      case 'read': return 'rgba(0, 212, 255, 0.1)';
      case 'replied': return 'rgba(16, 185, 129, 0.1)';
      case 'closed': return 'rgba(107, 114, 128, 0.1)';
      default: return 'rgba(107, 114, 128, 0.1)';
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const categories = [
    { value: 'general', label: 'General Inquiry', icon: '💬' },
    { value: 'support', label: 'Technical Support', icon: '🔧' },
    { value: 'billing', label: 'Billing Issue', icon: '💰' },
    { value: 'investment', label: 'Investment Question', icon: '📈' },
    { value: 'withdrawal', label: 'Withdrawal Issue', icon: '💸' },
    { value: 'suggestion', label: 'Suggestion', icon: '💡' },
    { value: 'complaint', label: 'Complaint', icon: '⚠️' }
  ];

  return (
    <div style={{
      padding: '20px',
      maxWidth: '1400px',
      margin: '0 auto',
      paddingBottom: '80px',
      backgroundColor: '#0a0a0a',
      minHeight: '100vh'
    }}>
      {/* Header */}
      <div style={{
        textAlign: 'center',
        marginBottom: '32px'
      }}>
        <h1 style={{
          fontSize: '32px',
          fontWeight: '700',
          background: 'linear-gradient(135deg, #00d4ff, #00d4ff)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          marginBottom: '8px'
        }}>Contact Us</h1>
        <p style={{ color: '#94a3b8' }}>We're here to help! Reach out to us anytime.</p>
      </div>
      
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
        gap: '32px',
        marginTop: '20px'
      }}>
        {/* Contact Form Section - Dark Theme */}
        <div style={{
          background: '#1a1a2e',
          borderRadius: '24px',
          border: '1px solid rgba(0, 212, 255, 0.2)',
          padding: '24px',
          height: 'fit-content'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px',
            paddingBottom: '15px',
            borderBottom: '2px solid rgba(0, 212, 255, 0.2)'
          }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '600',
              color: '#00d4ff',
              margin: 0
            }}>Send Us a Message</h2>
            <button 
              onClick={() => setShowForm(!showForm)}
              style={{
                background: 'rgba(0, 212, 255, 0.1)',
                border: '1px solid rgba(0, 212, 255, 0.3)',
                borderRadius: '8px',
                padding: '8px 16px',
                color: '#00d4ff',
                cursor: 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                transition: 'all 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = 'rgba(0, 212, 255, 0.2)'}
              onMouseLeave={(e) => e.currentTarget.style.background = 'rgba(0, 212, 255, 0.1)'}
            >
              {showForm ? 'Hide Form' : 'Show Form'}
            </button>
          </div>
          
          {showForm && (
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '20px' }}>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#e2e8f0',
                  marginBottom: '8px'
                }}>
                  Category *
                </label>
                <select
                  name="category"
                  value={contactForm.category}
                  onChange={handleInputChange}
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: '#0f0f0f',
                    border: '1px solid rgba(0, 212, 255, 0.3)',
                    borderRadius: '12px',
                    color: 'white',
                    fontSize: '14px',
                    outline: 'none',
                    cursor: 'pointer'
                  }}
                  required
                >
                  {categories.map(cat => (
                    <option key={cat.value} value={cat.value} style={{ background: '#1a1a2e' }}>
                      {cat.icon} {cat.label}
                    </option>
                  ))}
                </select>
              </div>
              
              <div style={{ marginBottom: '20px' }}>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#e2e8f0',
                  marginBottom: '8px'
                }}>
                  Subject *
                </label>
                <input
                  type="text"
                  name="subject"
                  value={contactForm.subject}
                  onChange={handleInputChange}
                  placeholder="Enter subject"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: '#0f0f0f',
                    border: '1px solid rgba(0, 212, 255, 0.3)',
                    borderRadius: '12px',
                    color: 'white',
                    fontSize: '14px',
                    outline: 'none',
                    transition: 'all 0.2s'
                  }}
                  onFocus={(e) => e.currentTarget.style.border = '1px solid #00d4ff'}
                  onBlur={(e) => e.currentTarget.style.border = '1px solid rgba(0, 212, 255, 0.3)'}
                  required
                />
              </div>
              
              <div style={{ marginBottom: '20px' }}>
                <label style={{
                  display: 'block',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#e2e8f0',
                  marginBottom: '8px'
                }}>
                  Message *
                </label>
                <textarea
                  name="message"
                  value={contactForm.message}
                  onChange={handleInputChange}
                  rows="6"
                  placeholder="Type your message here..."
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: '#0f0f0f',
                    border: '1px solid rgba(0, 212, 255, 0.3)',
                    borderRadius: '12px',
                    color: 'white',
                    fontSize: '14px',
                    outline: 'none',
                    resize: 'vertical',
                    fontFamily: 'inherit'
                  }}
                  onFocus={(e) => e.currentTarget.style.border = '1px solid #00d4ff'}
                  onBlur={(e) => e.currentTarget.style.border = '1px solid rgba(0, 212, 255, 0.3)'}
                  required
                />
              </div>
              
              <div style={{
                background: 'rgba(0, 212, 255, 0.1)',
                borderRadius: '12px',
                padding: '16px',
                marginBottom: '20px',
                borderLeft: '3px solid #00d4ff'
              }}>
                <p style={{
                  margin: '0 0 8px 0',
                  color: '#00d4ff',
                  fontSize: '14px',
                  fontWeight: '600'
                }}>📌 Tips for faster response:</p>
                <ul style={{
                  margin: 0,
                  paddingLeft: '20px',
                  color: '#94a3b8',
                  fontSize: '13px'
                }}>
                  <li>Be clear and specific about your issue</li>
                  <li>Include relevant account details if needed</li>
                  <li>Check our FAQ first for common questions</li>
                </ul>
              </div>
              
              <button 
                type="submit" 
                disabled={submitting}
                style={{
                  width: '100%',
                  padding: '14px',
                  background: submitting ? '#334155' : '#00d4ff',
                  border: 'none',
                  borderRadius: '12px',
                  color: '#1a1a2e',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: submitting ? 'not-allowed' : 'pointer',
                  transition: 'all 0.2s'
                }}
                onMouseEnter={(e) => {
                  if (!submitting) e.currentTarget.style.background = '#00e5ff';
                }}
                onMouseLeave={(e) => {
                  if (!submitting) e.currentTarget.style.background = '#00d4ff';
                }}
              >
                {submitting ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          )}
          
          <div style={{
            marginTop: '24px',
            paddingTop: '24px',
            borderTop: '1px solid rgba(0, 212, 255, 0.2)'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#00d4ff',
              marginBottom: '16px'
            }}>📞 Other Ways to Reach Us</h3>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '8px 0',
                borderBottom: '1px solid rgba(0, 212, 255, 0.1)'
              }}>
                <span style={{ fontSize: '20px' }}>📧</span>
                <div>
                  <strong style={{ color: '#e2e8f0' }}>Email:</strong>
                  <span style={{ color: '#94a3b8', marginLeft: '8px' }}>support@builtfuturelife.com</span>
                </div>
              </div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '8px 0',
                borderBottom: '1px solid rgba(0, 212, 255, 0.1)'
              }}>
                <span style={{ fontSize: '20px' }}>⏰</span>
                <div>
                  <strong style={{ color: '#e2e8f0' }}>Response Time:</strong>
                  <span style={{ color: '#94a3b8', marginLeft: '8px' }}>24-48 hours</span>
                </div>
              </div>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '8px 0'
              }}>
                <span style={{ fontSize: '20px' }}>🕒</span>
                <div>
                  <strong style={{ color: '#e2e8f0' }}>Working Hours:</strong>
                  <span style={{ color: '#94a3b8', marginLeft: '8px' }}>Monday-Friday, 9 AM - 6 PM GMT</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* My Contacts Section - Dark Theme */}
        <div style={{
          background: '#1a1a2e',
          borderRadius: '24px',
          border: '1px solid rgba(0, 212, 255, 0.2)',
          padding: '24px',
          maxHeight: '600px',
          overflowY: 'auto'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px',
            paddingBottom: '15px',
            borderBottom: '2px solid rgba(0, 212, 255, 0.2)'
          }}>
            <h2 style={{
              fontSize: '22px',
              fontWeight: '600',
              color: '#00d4ff',
              margin: 0
            }}>My Contact History</h2>
            <button 
              onClick={fetchMyContacts}
              disabled={loading}
              style={{
                background: 'rgba(0, 212, 255, 0.1)',
                border: '1px solid rgba(0, 212, 255, 0.3)',
                borderRadius: '8px',
                padding: '8px 16px',
                color: '#00d4ff',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500',
                opacity: loading ? 0.5 : 1,
                transition: 'all 0.2s'
              }}
            >
              {loading ? 'Refreshing...' : '🔄 Refresh'}
            </button>
          </div>
          
          {loading ? (
            <div style={{
              textAlign: 'center',
              padding: '40px',
              color: '#94a3b8'
            }}>
              <div style={{
                width: '40px',
                height: '40px',
                border: '3px solid rgba(0, 212, 255, 0.2)',
                borderTop: '3px solid #00d4ff',
                borderRadius: '50%',
                animation: 'spin 1s linear infinite',
                margin: '0 auto 16px'
              }} />
              <p>Loading your contacts...</p>
            </div>
          ) : myContacts.length === 0 ? (
            <div style={{
              textAlign: 'center',
              padding: '60px 20px',
              color: '#94a3b8'
            }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>📭</div>
              <p style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px' }}>No contacts yet</p>
              <p>Send us a message using the form on the left!</p>
            </div>
          ) : (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}>
              {myContacts.map(contact => (
                <div 
                  key={contact.id} 
                  onClick={() => viewContactDetails(contact.id)}
                  style={{
                    background: selectedContact?.id === contact.id ? 'rgba(0, 212, 255, 0.15)' : '#0f0f0f',
                    border: selectedContact?.id === contact.id ? '1px solid #00d4ff' : '1px solid rgba(0, 212, 255, 0.2)',
                    borderRadius: '16px',
                    padding: '16px',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={(e) => {
                    if (selectedContact?.id !== contact.id) {
                      e.currentTarget.style.border = '1px solid rgba(0, 212, 255, 0.5)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (selectedContact?.id !== contact.id) {
                      e.currentTarget.style.border = '1px solid rgba(0, 212, 255, 0.2)';
                    }
                  }}
                >
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    marginBottom: '12px'
                  }}>
                    <h4 style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#00d4ff',
                      margin: 0,
                      flex: 1
                    }}>{contact.subject}</h4>
                    <span style={{
                      background: getStatusBgColor(contact.status),
                      color: getStatusColor(contact.status),
                      padding: '4px 12px',
                      borderRadius: '20px',
                      fontSize: '12px',
                      fontWeight: '600',
                      textTransform: 'uppercase'
                    }}>
                      {contact.status}
                    </span>
                  </div>
                  <p style={{
                    color: '#94a3b8',
                    fontSize: '13px',
                    margin: '0 0 12px 0',
                    lineHeight: '1.5'
                  }}>
                    {contact.message.substring(0, 100)}...
                  </p>
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '12px'
                  }}>
                    <span style={{
                      background: 'rgba(0, 212, 255, 0.1)',
                      color: '#00d4ff',
                      padding: '4px 8px',
                      borderRadius: '12px',
                      fontSize: '11px'
                    }}>
                      {categories.find(c => c.value === contact.category)?.icon || '📌'} {contact.category}
                    </span>
                    <span style={{ color: '#64748b' }}>{formatDate(contact.submittedAt)}</span>
                  </div>
                  {contact.replies && contact.replies.length > 0 && (
                    <div style={{
                      marginTop: '12px',
                      paddingTop: '12px',
                      borderTop: '1px solid rgba(0, 212, 255, 0.1)',
                      color: '#10b981',
                      fontSize: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px'
                    }}>
                      <span>✓</span>
                      <span>{contact.replies.length} repl{contact.replies.length === 1 ? 'y' : 'ies'}</span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
          
          {/* Contact Details Modal - Dark Theme */}
          {selectedContact && (
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.9)',
              backdropFilter: 'blur(8px)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1000,
              padding: '20px'
            }}>
              <div style={{
                background: '#1a1a2e',
                borderRadius: '24px',
                border: '1px solid #00d4ff',
                maxWidth: '600px',
                width: '100%',
                maxHeight: '80vh',
                overflowY: 'auto',
                animation: 'slideUp 0.3s ease-out'
              }}>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '20px',
                  borderBottom: '1px solid rgba(0, 212, 255, 0.2)',
                  background: 'linear-gradient(135deg, rgba(0, 212, 255, 0.1), rgba(0, 212, 255, 0.05))'
                }}>
                  <h3 style={{
                    fontSize: '20px',
                    fontWeight: '600',
                    color: '#00d4ff',
                    margin: 0
                  }}>{selectedContact.subject}</h3>
                  <button 
                    onClick={() => setSelectedContact(null)}
                    style={{
                      background: 'rgba(255, 255, 255, 0.1)',
                      border: 'none',
                      borderRadius: '50%',
                      width: '36px',
                      height: '36px',
                      cursor: 'pointer',
                      color: '#94a3b8',
                      fontSize: '24px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    ×
                  </button>
                </div>
                
                <div style={{ padding: '24px' }}>
                  <div style={{ marginBottom: '24px' }}>
                    <h4 style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#00d4ff',
                      marginBottom: '16px'
                    }}>📋 Message Details</h4>
                    <div style={{
                      display: 'grid',
                      gap: '12px'
                    }}>
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '8px 0',
                        borderBottom: '1px solid rgba(0, 212, 255, 0.1)'
                      }}>
                        <strong style={{ color: '#94a3b8' }}>Category:</strong>
                        <span style={{ color: 'white' }}>
                          {categories.find(c => c.value === selectedContact.category)?.icon} {selectedContact.category}
                        </span>
                      </div>
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '8px 0',
                        borderBottom: '1px solid rgba(0, 212, 255, 0.1)'
                      }}>
                        <strong style={{ color: '#94a3b8' }}>Status:</strong>
                        <span style={{
                          color: getStatusColor(selectedContact.status),
                          background: getStatusBgColor(selectedContact.status),
                          padding: '4px 12px',
                          borderRadius: '20px',
                          fontSize: '12px'
                        }}>
                          {selectedContact.status}
                        </span>
                      </div>
                      <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        padding: '8px 0',
                        borderBottom: '1px solid rgba(0, 212, 255, 0.1)'
                      }}>
                        <strong style={{ color: '#94a3b8' }}>Submitted:</strong>
                        <span style={{ color: 'white' }}>{formatDate(selectedContact.submittedAt)}</span>
                      </div>
                    </div>
                  </div>
                  
                  <div style={{ marginBottom: '24px' }}>
                    <h4 style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#00d4ff',
                      marginBottom: '12px'
                    }}>💬 Your Message</h4>
                    <div style={{
                      background: '#0f0f0f',
                      borderRadius: '12px',
                      padding: '16px',
                      color: '#e2e8f0',
                      lineHeight: '1.6',
                      whiteSpace: 'pre-wrap',
                      border: '1px solid rgba(0, 212, 255, 0.2)'
                    }}>
                      {selectedContact.message}
                    </div>
                  </div>
                  
                  {selectedContact.replies && selectedContact.replies.length > 0 && (
                    <div>
                      <h4 style={{
                        fontSize: '16px',
                        fontWeight: '600',
                        color: '#00d4ff',
                        marginBottom: '16px'
                      }}>📨 Responses ({selectedContact.replies.length})</h4>
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px'
                      }}>
                        {selectedContact.replies.map(reply => (
                          <div key={reply.id} style={{
                            background: 'rgba(16, 185, 129, 0.1)',
                            borderRadius: '12px',
                            padding: '16px',
                            borderLeft: '3px solid #10b981'
                          }}>
                            <div style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                              marginBottom: '12px'
                            }}>
                              <strong style={{ color: '#10b981' }}>{reply.admin}</strong>
                              <span style={{ color: '#64748b', fontSize: '12px' }}>{formatDate(reply.date)}</span>
                            </div>
                            <p style={{
                              margin: 0,
                              color: '#e2e8f0',
                              lineHeight: '1.6'
                            }}>{reply.message}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @media (max-width: 768px) {
          .contact-container {
            padding-bottom: 80px;
          }
        }
        body {
          background-color: #0a0a0a;
        }
      `}</style>
    </div>
  );
};

export default ContactPage;